export default function () {
  return {
    data: null,
    loading: true,
    dataVersion: 0,
  }
}
